var $ = require('jquery');
var dashboardTabs;

dashboardTabs = function () {
    $(document).on('pjax:start pjax:end', addSelectClassToTab);

    function addSelectClassToTab() {
        removeAllSelectClassOfTabs();
        addSelectClassToCurrentActivatedTab();
    }

    function addSelectClassToCurrentActivatedTab() {
        $('.js-dashboardTabs').find('a[href$="' + window.location.pathname + '"]').parent('li').addClass('tab__item--selected');
    }

    function removeAllSelectClassOfTabs() {
        $('.js-dashboardTabs a').parent('li').removeClass('tab__item--selected');
    }
};

module.exports.init = dashboardTabs;
